import * as types from "../ActionTypes/actionTypes.js";

export default function (
  state = {
    isFetching: false,
    authenticated: false,
    isAuthenticated: !!localStorage.getItem("access_token"),
    actionType: "",
    errorMessage: "",
    materialUsageCSVSummary: [],
    workGangCSVSummary: [],
    lineInspectionCSVSummary: [],
    assetInspectionCSVSummary: [],
  },
  action,
) {
  switch (action.type) {
    case types.MATERIALUSAGECSV_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        isSuccess: false,
        errorMessage: "",
        actionType: action.type,
      };
    case types.MATERIALUSAGECSV_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        errorMessage: "",
        isSuccess: true,
        actionType: action.type,
        materialUsageCSVSummary: action.response,
      };
    case types.MATERIALUSAGECSV_GET_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.error || "Error: Unable to Get Summary.",
        isSuccess: false,
        actionType: action.type,
      };

    case types.WORKGANGCSV_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        isSuccess: false,
        errorMessage: "",
        actionType: action.type,
      };
    case types.WORKGANGCSV_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        errorMessage: "",
        isSuccess: true,
        actionType: action.type,
        workGangCSVSummary: action.response,
      };
    case types.WORKGANGCSV_GET_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.error || "Error: Unable to Get Summary.",
        isSuccess: false,
        actionType: action.type,
      };

    case types.LINEINSPECTIONCSV_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        isSuccess: false,
        errorMessage: "",
        actionType: action.type,
      };
    case types.LINEINSPECTIONCSV_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        errorMessage: "",
        isSuccess: true,
        actionType: action.type,
        lineInspectionCSVSummary: action.response,
      };
    case types.LINEINSPECTIONCSV_GET_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.error || "Error: Unable to Get Summary.",
        isSuccess: false,
        actionType: action.type,
      };

    case types.ASSETINSPECTIONCSV_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        isSuccess: false,
        errorMessage: "",
        actionType: action.type,
      };
    case types.ASSETINSPECTIONCSV_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        errorMessage: "",
        isSuccess: true,
        actionType: action.type,
        assetInspectionCSVSummary: action.response,
      };
    case types.ASSETINSPECTIONCSV_GET_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.error || "Error: Unable to Get Summary.",
        isSuccess: false,
        actionType: action.type,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reduxRelated/reducer/reportSummaryReducer.js